module.exports = __webpack_public_path__ + "static/media/it_30th_anniversary_logo@3x.01408f02.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/it_30th_anniversary_logo@3x.png
// module id = 62
// module chunks = 0